<script setup>
/* eslint-disable no-undef */
defineProps({
  title: {
    type: String,
    required: true
  },
  icon: {
    type: String,
    required: true
  },
  value: {
    type: String,
    default: '',
  },
  link: {
    type: String,
    default: ''
  },
  noBox: {
    type: Boolean,
    default: false
  }
})
</script>

<template>
  <div class="contact-card" :class="{ 'blurred-background': !noBox, 'contact-card-boxed': !noBox }">
    <h3 class="label">{{ title }}</h3>
    <a v-if="link" :href="link">{{ value }}</a>
    <p v-else-if="value" v-html="value"></p>
    <slot></slot>
  </div>
</template>

<style scoped>

.contact-card {
  padding: var(--spacing-md);
  display: flex;
  flex-direction: column;
  text-align: center;
  overflow: hidden;
}

.contact-card-boxed {
  border-radius: var(--box-border-radius);
  transition: transform var(--transition-normal), box-shadow var(--transition-normal);
  box-shadow: var(--shadow-md);
}

.contact-card-boxed:hover {
  transform: translateY(-4px);
  box-shadow: var(--shadow-lg);
}

.contact-card h3 {
  font-size: var(--font-size-m);
  color: var(--color-cream-dark);
  font-weight: var(--font-weight-bold);
  letter-spacing: var(--letter-spacing-tight);
  text-transform: uppercase;
  margin-bottom: var(--spacing-xs);
  padding-top: 0;
}

.contact-card a {
  font-size: var(--font-size-m);
  color: var(--color-cream);
  text-decoration: none;
  transition: color var(--transition-fast);
  line-height: var(--line-height-compact);
  text-align: left;
}

.contact-card a:hover {
  color: var(--color-cream-dark);
}

.contact-card p {
  font-size: var(--font-size-m);
  color: var(--color-cream);
  margin: 0;
  line-height: var(--line-height-compact);
}
</style>
